export class VoipScheduleRuleRow {
    public scheduleType: string = 'Normal';
    public weekDays: number[] = [];
    public startTime: any;
    public endTime: any;
}